<template>
    <div :class="'navigation-view-' + type" class="navigation-view-wrapper">
        <div class="navigation-view-title" v-if="views.length && type !== 'history' && type !== 'min'">{{title}}</div>
        <div v-for="(view, index) in views" :key="index">
            <div v-if="type === 'max'" class="navigation-view-item">
                <component :is="view.cType" v-bind="view"></component>
            </div>
            <div v-else-if="view.title || view.cId || view.windowName" class="navigation-view-item">
                <div class="navigation-view-item-header">{{ view.title || view.cId || view.windowName }}</div>
                <navigation-buttons :view="view" :used-from="type"></navigation-buttons>
            </div>
        </div>
        <div v-if="!views.length" class="navigation-view-empty">
            No items in {{ title }}
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "vue";

let navigationViewsCmp = {
    name: 'navigationViews',
    props: {
        type: {
            default: false
        }
    },
    data() {
        return {};
    },
    mounted() {
        if (this.type) {
            this.navigationStore?.allowedButtons?.push?.(this.type);
        }
    },
    computed: {
        navigationStore() {
            return typeof navigationStore === 'function' ? navigationStore() : {};
        },
        title() {
            let title = '';
            switch (this.type) {
                case 'min':
                    title = 'Minimized';
                    break;
                case 'max':
                    // title = 'Maximize';
                    break;
                case 'history':
                    title = 'History';
                    break;
            }
            return title;
        },
        views() {
            let views = [];
            if (this.type === 'history') {
                views = this.navigationStore?.history || [];
            } else if (this.type === 'min' || this.type === 'max') {
                let tmpViews = this.navigationStore?.views;
                for (let i in tmpViews) {
                    if (tmpViews[i].openedIn === this.type) {
                        views.push(tmpViews[i].config);
                    }
                }
            }
            return views;
        },
    },
    methods: {},
    components: {
        'navigation-buttons': defineAsyncComponent(() => import('@common/navigation/navigationButtons')),
    },
};

export { navigationViewsCmp };
export default navigationViewsCmp;
</script>

<style scoped>
.navigation-view-wrapper {
    display: flex;
    flex-direction: column;
}

.navigation-view-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    padding: 0.625rem 1rem;
    border-bottom: 1px solid #f3f4f6;
    transition: background-color 0.12s ease;
}

.navigation-view-item:hover {
    background-color: #f9fafb;
}

.navigation-view-item-header {
    flex: 1;
    min-width: 0;
    font-size: 0.875rem;
    font-weight: 500;
    color: #111827;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4;
}

.navigation-view-empty {
    padding: 2.5rem 1rem;
    text-align: center;
    font-size: 0.875rem;
    color: #9ca3af;
}
</style>
